import { Box } from "@mui/material"
import { useAuthContext } from "src/hooks"
import { theme } from "src/providers/ThemeProvider"
import { Text } from "src/shared"
import ProfileButton from "./ProfileButton"

const RightNavbar = () => {
  const { hasAuthenticated, profile } = useAuthContext()

  return (
    <Box
      sx={{
        "& button": {
          "& > p": {
            color: "white",
            fontSize: 16,
            fontWeight: 400,
            lineHeight: "21px",
          },
          padding: 0,
          width: "auto",
        },
        [theme.breakpoints.down(600)]: {
          top: 20,
          right: 20,
          flexDirection: "column",
          maxWidth: 80,
        },
      }}
      display="flex"
      gap={1}
      alignItems="end"
      position="absolute"
      top={30}
      right={40}
    >
      {hasAuthenticated && !!profile ? (
        <Box
          display="flex"
          gap={2}
          alignItems="center"
          color="white"
          textAlign="right"
          sx={{
            [theme.breakpoints.down(600)]: {
              flexDirection: "column-reverse",
              "& svg": {
                width: 40,
                height: 40,
              },
              "& > p": {
                fontSize: 14,
                lineHeight: "18px",
              },
              alignItems: "end",
            },
          }}
        >
          <Text fontSize={16} lineHeight="21px">
            {profile?.FullName}
          </Text>
          <ProfileButton />
        </Box>
      ) : (
        <></>
      )}
    </Box>
  )
}

export default RightNavbar
